/*
 *
 *   SugarWOD
 *   shared.js
 *
 */

// CONSTANTS

const { modalLoadUrl } = require("@sugarfrontend/modules/modals");

// DOCUMENT READY
function isDefined(value) {
    return value !== undefined && value !== null;
}

// AJAX UTILITIES
function ajaxJSON(verb, url, data, successFn, message, errorFn) {
    showActivityAnimation(true, message);

    data = data || {};

    // always need the csrf token
    /* global CSRF */
    data._csrf = CSRF;

    // standard params
    var params = {
        cache: false,
        url: url,
        dataType: "json",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        data: data,

        success: function (result, textStatus, jQxhr) {
            showActivityAnimation(false);

            if (successFn && typeof successFn === "function") {
                successFn(result);
            }
        },

        error: function (jqXhr, textStatus, errorThrown) {
            showActivityAnimation(false);

            console.error(verb, url, textStatus, errorThrown);

            if (jqXhr.status === 401) {
                // skip errorFn for timeout and show modal login
                const responseJSON = jqXhr.responseJSON;
                if (
                    isDefined(responseJSON) &&
                    isDefined(responseJSON.subCode) &&
                    responseJSON.subCode === "timeout"
                ) {
                    // close any existing dialogue
                    $(".modal").modal("hide");

                    // load login in modal
                    return modalLoadUrl(
                        "/login?modal=true&url=" + window.location.href,
                        "md"
                    );
                }
            }

            if (errorFn && typeof errorFn === "function") {
                errorFn(jqXhr.responseJSON || errorThrown);
            }
        },
    };

    // put | patch | delete need different params
    if (verb.toLowerCase() !== "get") {
        data._method = verb;

        params.method = "post";
        params.data = JSON.stringify(data);
        params.contentType = "application/json";
    }

    $.ajax(params);
}

function getAsyncJSON(url, data, message, successFn, errorFn) {
    ajaxJSON("get", url, data, successFn, message, errorFn);
}

function postAsyncJSON(url, data, message, successFn, errorFn) {
    ajaxJSON("post", url, data, successFn, message, errorFn);
}

function deleteAsyncJSON(url, data, message, success) {
    ajaxJSON("delete", url, data, success, message);
}

function patchAsyncJSON(url, data, message, successFn, errorFn) {
    ajaxJSON("patch", url, data, successFn, message, errorFn);
}

function postMultipartFormAjax(url, formData, successFn, errorFn) {
    showActivityAnimation(true, "Uploading...");

    // csrf moved to the query string for file uploads
    // was causing problems being in the body.
    url += "?_csrf=" + CSRF;

    // standard params
    var params = {
        method: "post",
        cache: false,
        url: url,
        data: formData,

        headers: {
            Accept: "application/json",
        },

        processData: false,
        contentType: false,

        success: function (result, textStatus, jQxhr) {
            showActivityAnimation(false);
            successFn(result);
        },

        error: function (jqXhr, textStatus, errorThrown) {
            showActivityAnimation(false);
            if (errorFn) {
                errorFn(errorThrown);
                return;
            }

            // todo: default (bad) error handling
            console.error(errorThrown);
        },
    };

    $.ajax(params);
}

// ACTIVITY
function showActivityAnimation(show, message) {
    if (show) {
        $(".activity-animation").removeClass("hidden");

        if (isDefined(message)) {
            $(".activity-message").removeClass("hidden");
            $(".activity-message").text(message);
        }
    } else {
        $(".activity-animation").addClass("hidden");
    }
}

// BROWSER DETECTION
function isFirefoxBrowser() {
    return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
}

function isMicrosoftBrowser() {
    var ua = window.navigator.userAgent.toLowerCase();
    return (
        ua.indexOf("msie") > -1 ||
        ua.indexOf("trident") > -1 ||
        ua.indexOf("edge") > -1
    );
}

function animateMenuOnPageScroll(menu, offset) {
    var lastId;
    var offset = typeof offset == "undefined" ? 0 : offset;
    var menuHeight = $(menu).height();
    var menuItems = $(menu).find("a.scrollTo");

    var scrollItems = menuItems.map(function () {
        var item = $($(this).attr("href"));
        if (item.length && item.selector[0] === "#") {
            return item;
        }
    });

    $(window).scroll(function () {
        // Get container scroll position
        var fromTop = $(this).scrollTop() + menuHeight + offset;
        // Get id of current scroll item
        var cur = scrollItems.map(function () {
            if ($(this).offset().top < fromTop) {
                return this;
            }
        });
        cur = cur[cur.length - 1];
        var id = cur && cur.length ? cur[0].id : "";
        if (lastId !== id) {
            lastId = id;
            menuItems.removeClass("active");
            menuItems.filter("[href=#" + id + "]").addClass("active");
        }
    });
}

// BUTTONS
function enableButton(buttonEl, isEnabled) {
    if (isEnabled === true) {
        buttonEl.removeAttr("disabled");
    } else {
        buttonEl.attr("disabled", "disabled");
    }
}

function setButtonWorkingIndicator(buttonEl, showIndicator, workingLabel) {
    if (showIndicator) {
        var labelText = buttonEl.text();
        buttonEl.data("original-text", labelText);
        workingLabel = workingLabel || labelText;

        buttonEl
            .empty()
            .html(
                $("<span>")
                    .append($('<span class="button-label">').text(labelText))
                    .append(
                        $(
                            '<i class="fa fa-refresh fa-spin" style="margin-left:1em; ">'
                        )
                    )
            );
        enableButton(buttonEl, false);
    } else {
        var labelText = buttonEl.data("original-text");
        buttonEl.empty().text(labelText);
        enableButton(buttonEl, true);
    }
}

// URLs
function getQueryParams(qs) {
    // http://stackoverflow.com/questions/979975/how-to-get-the-value-from-the-url-parameter
    // var query = getQueryParams(document.location.search);

    qs = qs.split("+").join(" ");

    var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while ((tokens = re.exec(qs))) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
}

function getParamsFromQuery(search = window.location.search) {
    return Object.fromEntries(new URLSearchParams(search));
}

function affiliateLogoURL(potentialURL) {
    // returns a url for the affiliate logo image or a placeholder
    return isDefined(potentialURL) && potentialURL.length
        ? potentialURL
        : "http://cdn.sugarwod.com/static/images/logos/icon-gray-700.png";
}

// EMAIL
function validateEmail(email) {
    // http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
    var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

// ARRAYS
function removeFromArray(anArray, obj) {
    // modifies the original array in place
    // if obj not found, no change
    var idx = anArray.indexOf(obj);
    if (idx !== -1) {
        anArray.splice(idx, 1);
    }
}

function insertIntoArray(anArray, obj, idx) {
    // modifies the original array in place
    anArray.splice(idx, 0, obj);
}

function moveWithinArray(anArray, obj, idxTo) {
    // moves obj from its current position to a new idx
    removeFromArray(anArray, obj);
    insertIntoArray(anArray, obj, idxTo);
}

function arraysHaveSameItems(a, b) {
    return a.length === b.length && a.length === _.intersection(a, b).length;
}

// ANIMATION
function removeAllAnimations(el) {
    var animations =
        "bounce flash pulse rubberBand shake swing tada wobble jello bounceIn bounceInDown bounceInLeft bounceInRight bounceInUp bounceOut bounceOutDown bounceOutLeft bounceOutRight bounceOutUp fadeIn fadeInDown fadeInDownBig fadeInLeft fadeInLeftBig fadeInRight fadeInRightBig fadeInUp fadeInUpBig fadeOut fadeOutDown fadeOutDownBig fadeOutLeft fadeOutLeftBig fadeOutRight fadeOutRightBig fadeOutUp fadeOutUpBig flipInX flipInY flipOutX flipOutY lightSpeedIn lightSpeedOut rotateIn rotateInDownLeft rotateInDownRight rotateInUpLeft rotateInUpRight rotateOut rotateOutDownLeft rotateOutDownRight rotateOutUpLeft rotateOutUpRight hinge rollIn rollOut zoomIn zoomInDown zoomInLeft zoomInRight zoomInUp zoomOut zoomOutDown zoomOutLeft zoomOutRight zoomOutUp slideInDown slideInLeft slideInRight slideInUp slideOutDown slideOutLeft slideOutRight slideOutUp";
    el.removeClass("animated " + animations);
}

function animateElement(el, animationClass, delay, onEndFn) {
    removeAllAnimations(el);
    el.addClass("animated " + animationClass);

    if (delay) {
        el.css({
            "-webkit-animation-delay": delay + "s",
            "animation-delay": delay + "s",
        });
    }

    if (onEndFn) {
        el.one(
            "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
            onEndFn(el)
        );
    }
}

// TEMPLATES
function cloneTemplate(templateClass, elementId) {
    // Find the template in the #templates div
    const templateElement = $(`#templates .${templateClass}`);

    // Clone the children of the template and remove the template class to avoid confusion later.
    const clonedElement = templateElement.children().clone();

    // Assign an ID if provided
    if (isDefined(elementId)) clonedElement.prop({ id: elementId });

    return clonedElement;
}

// used to prevent XSS injection attacks
function escapeHtmlEntities(input) {
    const map = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#x27;",
        "/": "&#x2F;",
    };
    const reg = /[&<>"'/]/gi;
    return input.replace(reg, (match) => map[match]);
}

// Created as a step to moving away from using the Underscore library.
function indexBy(array, property) {
    return array.reduce((result, item) => {
        result[item[property]] = item;
        return result;
    }, {});
}

const MONTH_OPTIONS = [
    { id: "", text: "" },
    { id: "January", text: "January" },
    { id: "February", text: "February" },
    { id: "March", text: "March" },
    { id: "April", text: "April" },
    { id: "May", text: "May" },
    { id: "June", text: "June" },
    { id: "July", text: "July" },
    { id: "August", text: "August" },
    { id: "September", text: "September" },
    { id: "October", text: "October" },
    { id: "November", text: "November" },
    { id: "December", text: "December" },
];

const getYearsUpTo = (upToYears = 100) => {
    let yearOptions = [];
    yearOptions.push({ id: "", text: "" });
    let currentYear = new Date().getFullYear();
    for (let i = currentYear - 1; i >= currentYear - (upToYears + 1); i--) {
        yearOptions.push({ id: i, text: `${i}` });
    }
    return yearOptions;
};

const gatDaysUpTo = (upToDates = 31) => {
    const dateOptions = [];
    dateOptions.push({ id: "", text: "" });
    for (let i = 1; i <= upToDates; i++) {
        dateOptions.push({ id: i, text: `${i}` });
    }
    return dateOptions;
};

module.exports = {
    isDefined,
    ajaxJSON,
    getAsyncJSON,
    postAsyncJSON,
    deleteAsyncJSON,
    patchAsyncJSON,
    postMultipartFormAjax,
    showActivityAnimation,
    isFirefoxBrowser,
    isMicrosoftBrowser,
    animateMenuOnPageScroll,
    enableButton,
    setButtonWorkingIndicator,
    getQueryParams,
    affiliateLogoURL,
    validateEmail,
    removeFromArray,
    insertIntoArray,
    moveWithinArray,
    arraysHaveSameItems,
    removeAllAnimations,
    animateElement,
    cloneTemplate,
    escapeHtmlEntities,
    indexBy,
    MONTH_OPTIONS,
    getYearsUpTo,
    gatDaysUpTo,
    getParamsFromQuery,
};
